import styled from 'styled-components';

import COLORS from '@mlb/react-patterns/style/universal.color';
import { StyledButton, Label } from '@mlb/react-patterns/components/Button/button.style.tsx';

const PopoverContent = styled.div`
    display: flex;
    flex-direction: column;
    padding: 6px;
    min-width: 142px;
    background: ${COLORS.mlbWhite};
    border-radius: 4px;

    ${StyledButton} {
        text-align: left;
        font-weight: 600;
        white-space: nowrap;
        font-size: 17px;
        &:focus {
            position: relative;
            z-index: 10;
            outline: 5px auto Highlight;
            outline: 5px auto -webkit-focus-ring-color;
        }
    }

    ${Label} {
        margin-left: 12px;
    }
`;

export default PopoverContent;
